import React from 'react';

export default function Layout({ children }) {
    return (
        <main className="main-layout" style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
        }}>
            {children}
        </main>
    );
}